import { render, staticRenderFns } from "./pagina.vue?vue&type=template&id=4b52dca4&scoped=true&"
import script from "./pagina.ts?vue&type=script&lang=ts&"
export * from "./pagina.ts?vue&type=script&lang=ts&"
import style0 from "./pagina.vue?vue&type=style&index=0&id=4b52dca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52dca4",
  null
  
)

export default component.exports